import React, { useState } from 'react';
import swal from 'sweetalert';

import useGlobalState from '../GlobalStateContext';
import { handleResponseError } from '../helpers/ResponseErrorHelper';
import { OptionalRolesOrPermissions } from '../helpers/Permissions';
import axios from '../services/MyAxios';

import useIsMounted from 'crm/hooks/useIsMounted';

type Props = {
    url?: string;
    action: Function;
} & OptionalRolesOrPermissions;

export default function DeleteButton({ url, action, roles = [], permissions = [] }: Props) {
    const [loading, setLoading] = useState(false);
    const { loggedAdmin } = useGlobalState();
    const isMounted = useIsMounted();

    const handleDeleteClick = async () => {
        if (loading) {
            return;
        }

        const confirmed = await swal({
            title: 'Delete Resource',
            text: 'Are you sure you want to delete this resource?',
            icon: 'warning',
            buttons: true as any,
            dangerMode: true,
        });

        if (!confirmed) {
            return;
        }

        setLoading(true);

        try {
            if (url) {
                await axios.delete(url);
            }
            await action();
        } catch (error) {
            handleResponseError(error);
        } finally {
            if (isMounted()) {
                setLoading(false);
            }
        }
    };

    function getContent() {
        if (loading) {
            return (
                <span className="btn btn-primary btn-sm square-button">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                </span>
            );
        }

        return (

            <button className="btn btn-primary btn-sm square-button m-0" type="button" onClick={handleDeleteClick}>
                <i className="fa fa-trash-alt" />
            </button>
        );
    }

    return loggedAdmin.hasAccess(roles, permissions) ? getContent() : null;
}
